import { NgIf, AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { TranslatePipe } from '@next/core-lib/i18n';
import { RouterSelectors } from '@next/core-lib/router-store';
import { AccessRoleTypes, UserSelectors } from '@next/core-lib/user';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApplicationKeys } from 'src/app/shared/models/shared.model';

@Component({
  selector: 'app-settings-navigation',
  templateUrl: 'settings-navigation.component.html',
  imports: [MatTabNav, NgIf, MatTabLink, RouterLink, MatTabNavPanel, AsyncPipe, TranslatePipe],
})
export class SettingsNavigationComponent {
  private readonly store = inject<Store<RootState>>(Store);

  routeUrl$: Observable<string> = this.store.pipe(select(RouterSelectors.getPath));

  isBarn$: Observable<boolean> = this.routeUrl$.pipe(map((url) => url.indexOf('barn') > 0));

  isPerformance$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('performancesetting') > 0),
  );

  isFarmResultSetting$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('farmresultsetting') > 0),
  );

  isFinalSetupSetting$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('finalsetupsetting') > 0),
  );

  isDiscountSetting$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('discountsetting') > 0),
  );

  isAdvisor$: Observable<boolean> = this.store.pipe(
    select(AuthorizationSelectors.hasAtLeastAdvisorRole),
  );

  isSustainability$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('settings/sustainability') > 0),
  );
  showSustainability$: Observable<boolean> = this.store
    .select(UserSelectors.selectUserApplications)
    .pipe(
      map((apps) =>
        apps.some(
          (app) =>
            app.ApplicationKey === ApplicationKeys.PoultryNextSustainability &&
            app.RoleKey === AccessRoleTypes.GlobalAdministrator,
        ),
      ),
    );

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}
}
